import React, { useMemo } from 'react';
import classNames from 'classnames';
import RoundedGoBackButton from '../../../controls/RoundedGoBackButton';
import RoundedLinkButton from '../../../controls/RoundedLinkButton';
import RoundedPrimaryButton from '../../../controls/RoundedPrimaryButton';
import { useIsOnline } from '../../../utils/InternetConnectionProvider';
import Spinner from '../../../utils/Spinner';
import useTranslation from '../../../utils/Translations/useTranslation';
import { useEditSession } from '../../EditSessionProvider';
import useEntityFormContext from './useEntityFormContext';
import styles from './SubmitSection.scss';
const SimpleSubmitSection = ({ goBackLabel = '', isNew = false, isDisable = false, onGoBack, onSubmit, submitLabel = '', isEditable = false, isRoundedLinkButton = false, }) => {
    const { t, direction, isLayoutRTL } = useTranslation();
    const rtlMarginClass = isLayoutRTL ? 'ml-5' : 'mr-5';
    const { dirty, isSubmitting } = useEntityFormContext();
    const { isEditSessionActive } = useEditSession();
    const buttonLabel = useMemo(() => isEditSessionActive || isEditable
        ? goBackLabel || t('Go Back')
        : t('Close'), [t, goBackLabel, isEditable, isEditSessionActive]);
    const { isOnline } = useIsOnline();
    const isSubmitDisabled = useMemo(() => !isOnline || isSubmitting || (!isNew && !dirty) || isDisable, [isOnline, isSubmitting, isNew, dirty, isDisable]);
    const renderSubmit = useMemo(() => isNew || isEditSessionActive || isEditable, [isNew, isEditSessionActive, isEditable]);
    const label = useMemo(() => {
        if (isSubmitting) {
            return <Spinner />;
        }
        if (submitLabel) {
            return submitLabel;
        }
        if (isNew) {
            return t('Create');
        }
        return t('Update');
    }, [isSubmitting, submitLabel, isNew, t]);
    if (!onGoBack && !renderSubmit)
        return null;
    return (<div className="row">
      <div className={classNames('action-section mt-10 col-xs-12', {
        [styles.rtlActionSection]: isLayoutRTL,
    })} data-layout-direction={direction} dir={direction}>
        {onGoBack &&
        (isRoundedLinkButton ? (<RoundedLinkButton additionClasses={rtlMarginClass} onClick={onGoBack}>
              {buttonLabel}
            </RoundedLinkButton>) : (<RoundedGoBackButton additionClasses={classNames('btn btn-flat legitRipple', {
            [styles.rtlGoBackSpacing]: isLayoutRTL,
        })} onClick={onGoBack}>
              {buttonLabel}
            </RoundedGoBackButton>))}
        {renderSubmit && (<>
            &nbsp;
            {onSubmit && (<RoundedPrimaryButton additionClasses="btn btn-primary legitRipple" disabled={isSubmitDisabled} type="button" onClick={onSubmit}>
                {label}
              </RoundedPrimaryButton>)}
            {!onSubmit && (<RoundedPrimaryButton additionClasses="btn btn-primary legitRipple" disabled={isSubmitDisabled} type="submit">
                {label}
              </RoundedPrimaryButton>)}
          </>)}
      </div>
    </div>);
};
export default SimpleSubmitSection;
